import theme from '@css/theme';
import AntTabs from 'antd/lib/tabs';
import styled from 'styled-components';

export const StyledTabs = styled(AntTabs)`
  .ant-tabs-nav {
    margin-bottom: 24px;
  }
  .ant-tabs-nav-wrap {
    padding-left: 16px;
  }
  &.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: 1px solid ${theme.color.border};
  }
  &.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
    background: ${theme.color.rsPrimary} !important;
  }
  .ant-tabs-tab-btn {
    font-size: 14px;
    font-weight: 500;
    color: ${theme.color.neutral2};
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${theme.color.rsPrimary};
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 60px;
  }
`;
